// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2jjRV","row":"Node_row__3HxI9","label":"Node_label__2aGil","footer":"Node_footer__3INhs"};